module.exports = __webpack_public_path__ + "static/img/va-new-b.6cc5c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/va-new-b.png
// module id = rNba
// module chunks = 1